(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.mobileMenu = this.querySelector('header-drawer');
      this.currentScrollTop = 0;
      this.preventHide = false;
      this.preventReveal = false;

      this.headerCoords = {};
      this.fold = 0;
      this.revealedAt = 0;
      this.measure();

      this.onScrollHandler = this.onScroll.bind(this);
      /* Phones fire resize as the address bar shows and hides; that never changes the
         header, so only a real width change (or fonts and images settling) re-measures. */
      this.onResizeHandler = (event) => {
        if (event && event.type === 'resize' && window.innerWidth === this.measuredWidth) return;
        cancelAnimationFrame(this.resizeFrame);
        this.resizeFrame = requestAnimationFrame(() => this.measure());
      };
      this.enableScroll();
      window.addEventListener('resize', this.onResizeHandler);
      window.addEventListener('load', this.onResizeHandler, { once: true });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.onResizeHandler);
    }

    disconnectedCallback() {
      this.disableScroll();
      window.removeEventListener('resize', this.onResizeHandler);
    }

    /* NEM: the compact bar is shorter than the full header. Measure both, hand the difference
       back as margin (--nem-fold) so the page never moves, and only allow the compact bar once
       the full header is far enough off screen that the returned space can't show as a strip. */
    measure() {
      /* Measure the header in its plain resting state: no sticky, no slide, no transitions.
         A header that is slid away (hidden) or mid-animation would otherwise report a
         shifted position and leave the compact bar stuck with a strip under it. The state
         is restored before the browser paints, so nothing visible changes. */
      const cls = this.header.classList;
      const state = ['shopify-section-header-sticky', 'shopify-section-header-hidden', 'animate'].filter((c) => cls.contains(c));
      cls.add('nem-header-measuring');
      cls.remove('shopify-section-header-sticky', 'shopify-section-header-hidden', 'animate');
      const fullHeight = this.header.offsetHeight;
      this.calcHeaderCoords();
      cls.add('shopify-section-header-sticky');
      const compactHeight = this.header.offsetHeight;
      cls.remove('shopify-section-header-sticky');
      state.filter((c) => c !== 'animate').forEach((c) => cls.add(c));
      void this.header.offsetHeight; // settle the restored state before transitions return
      cls.remove('nem-header-measuring');
      if (state.includes('animate')) cls.add('animate');
      this.fold = Math.max(0, fullHeight - compactHeight);
      this.header.style.setProperty('--nem-fold', this.fold + 'px');
      this.compactLimit = this.headerCoords.top + this.fold;
      this.measuredWidth = window.innerWidth;
    }

    calcHeaderCoords() {
      const clientRect = this.header.getBoundingClientRect();
      const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
      this.headerCoords.bottom = pageYOffset + clientRect.bottom;
      this.headerCoords.top = pageYOffset + clientRect.top;
    }

    onScroll(event) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky) {
        if (scrollTop > this.header.offsetHeight + 1) {
          this.header.classList.add('shopify-section-header-sticky');
        }

        if (scrollTop < this.header.offsetHeight) {
          this.header.classList.remove('shopify-section-header-sticky');
        }
      }

      const cls = this.header.classList;
      const compactShowing = cls.contains('shopify-section-header-sticky') && !cls.contains('shopify-section-header-hidden') && performance.now() - this.revealedAt > 900;
      if (scrollTop < this.compactLimit || (scrollTop < this.headerCoords.bottom && !compactShowing)) {
        requestAnimationFrame(this.reset.bind(this));
      } else if (scrollTop > this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventHide || (this.mobileMenu && this.mobileMenu.isOpen && window.innerWidth <= 1160)) {
          this.currentScrollTop = scrollTop;
          return;
        }
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop) {
        if (this.preventReveal) {
          this.currentScrollTop = scrollTop;
          return;
        }
        requestAnimationFrame(this.reveal.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      const y = window.pageYOffset || document.documentElement.scrollTop;
      if (y <= this.headerCoords.bottom) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      const y = window.pageYOffset || document.documentElement.scrollTop;
      if (y < this.headerCoords.bottom) return;
      if (!this.header.classList.contains('shopify-section-header-sticky') || this.header.classList.contains('shopify-section-header-hidden')) {
        this.revealedAt = performance.now();
      }
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      const y = window.pageYOffset || document.documentElement.scrollTop;
      const cls = this.header.classList;
      const compactShowing = cls.contains('shopify-section-header-sticky') && !cls.contains('shopify-section-header-hidden') && performance.now() - this.revealedAt > 900;
      if (y >= this.headerCoords.bottom || (compactShowing && y >= this.compactLimit)) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    enableScroll() {
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disableScroll() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
